import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_PATIENT_EXERCISES_BY_ID_KEY } from '_api/queries/exercise/useGetAllPatientExercisesByID';
import { AddExerciseToPatientPayload } from '_api/types';

export const ADD_EXERCISE_TO_PATIENT_KEY = 'add-exercise-to-patient';

export const useAddExerciseToPatient = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, AddExerciseToPatientPayload[]>(
    () => '/exercise/add-patient-exercise-setting',
    'post',
    {},
    {
      mutationKey: [ADD_EXERCISE_TO_PATIENT_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_EXERCISES_BY_ID_KEY],
        });
      },
    },
    (body: AddExerciseToPatientPayload[]) => JSON.stringify(body),
  );
};
